<template>
  <Catalog
    title="Тип расхода исполнителя"
    name-label="Название"
    description-label="Например: Одежда, Трансфер, Питание"
    submit-error="Укажите название расхода исполнителя."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "WorkerCostType",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getWorkerCostTypeById(id);
    },
    async putData(data) {
      return await this.putWorkerCostType(data)
    },
    async postData(data) {
      return await this.postWorkerCostType(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerCostTypes/WorkerCostType.vue